import * as Yup from 'yup';

import { MAX_FILE_SIZE_5MB } from '@/common/constants';

export const invoicePaymentSchema = (role: string) => {
    role ??= ""; // default to empty string if role is undefined to avoid type error
    return Yup.object({
      paymentDate: Yup.date().required("Payment date is required"),
      // amountIDR:
      //   role === ROLES.FINANCE
      //     ? Yup.string()
      //         .required("IDR amount is required")
      //         .matches(
      //           /^IDR[1-9][\d.,]*/,
      //           "IDR amount cannot be zero or negative"
      //         )
      //     : Yup.string().nullable(),
      paymentFile: Yup.mixed()
        .test("fileSize", "File size is too large", (value: any) => {
          if (value.size > MAX_FILE_SIZE_5MB) {
            return false;
          }

          return true;
        })
        .required("Payment file is required"),
    });
}
